/**
 * MFA
 */
export const MFA = (function () {
    var init =  function () {  
        var form1 = document.getElementById('mfa-add');
        var button1 = document.getElementById('button-add');
        var form2 = document.getElementById('mfa-confirm');
        var button2 = document.getElementById('button-confirm');
        var form3 = document.getElementById('mfa-resend');
        var button3 = document.getElementById('button-resend');

        if (form1 && button1) {
           form1.addEventListener('submit', function () {
                button1.disabled = true;
                button1.innerText = 'Adding...';
            });
        }
        if (form2 && button2) {
            form2.addEventListener('submit', function () {
                button2.disabled = true;
                button2.innerText = 'Verifying...';
            });
        }
        if (form3 && button3) {
            form3.addEventListener('submit', function () {
                button3.disabled = true;
                button3.innerText = 'Resending...';
            });
        }

        // These are for the MFA setup screen - backup codes
        var copyButton = document.getElementById('copyButton');
        var printButton = document.getElementById('printButton');
        var backupCodesTable = document.getElementById('backup-codes-table');

        if (backupCodesTable) {
            // Function to copy table content to clipboard
            copyButton.addEventListener('click', () => {
                // Create a temporary textarea to hold the table content
                const textarea = document.createElement('textarea');
                textarea.value = backupCodesTable.innerText; // Copy the text content of the table
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                const originalText = copyButton.innerText; // Store the original text
                copyButton.innerText = 'Copied to clipboard!'; // Change to the new text
                setTimeout(() => {
                    copyButton.innerText = originalText; // Revert to the original text
                }, 5000); // 5000 milliseconds = 5 seconds
            });

            // Function to print the table
            printButton.addEventListener('click', () => {
                const printWindow = window.open('', '', 'height=600,width=800');
                printWindow.document.write('<html><head><title>My MydexID backup codes</title>');
                printWindow.document.write('</head><body >');
                printWindow.document.write(backupCodesTable.outerHTML); // Print the table HTML
                printWindow.document.write('</body></html>');
                printWindow.document.close();
                printWindow.focus();
                printWindow.print();
            });
        }
    }
  
    return {
      init: init
    }
  
}());
